/**
 * ROI Calculator — FOG Theme
 *
 * Inputs :
 *   power        : puissance actuelle d'une lampe (W)
 *   qty          : nombre de lampes (entier)
 *   kwh          : prix kWh (CHF), virgule ou point acceptés
 *   hours        : heures par jour (au plus 24)
 *   paybackCoef  : coefficient payback bas, CHF par W remplace (defaut 0.63)
 *   paybackCoefMax : coefficient payback haut (defaut 0.95)
 *
 * Formules :
 *   case5  = (power * qty / 1000) * hours * 365            (Conso actuelle 1 an kWh)
 *   case6  = case5 * 0.6                                   (Conso FOG 1 an kWh = 60% de l'actuelle)
 *   case7  = case5 - case6                                 (Economie 1 an kWh)
 *   case13 = case7 * kwh                                   (Economie/Perte annuelle CHF)
 *   case9  = case13 / 12                                   (Economie/Perte mensuelle CHF)
 *   case14 = case13 * 5                                    (Economie/Perte 5 ans CHF)
 *   case1  = case13                                        (Economie 1 an CHF)
 *   case2  = case14                                        (Economie 5 ans CHF)
 *   case4  = (power * qty * paybackCoef) / case9           (Payback bas, mois, independant de la puissance)
 *   case4Max = (power * qty * paybackCoefMax) / case9      (Payback haut, mois)
 *   case11 = case13                                        (Gain annuel CHF)
 *   case12 = case14                                        (Gain 5 ans CHF)
 *
 * Formule payback (logique Fabrizio FOG) :
 *   - Lampe FOG : 1 CHF/W (lampe 600W = 600 CHF).
 *   - Pour remplacer 1 lampe HPS de N W, on installe 1 lampe FOG de N*0.6 W.
 *   - Investissement total = power * qty * 0.6 (en CHF).
 *   - Payback = investissement / economie mensuelle.
 *   - Exemple avec les valeurs par defaut du formulaire (1000W, 10 lampes, 0.27 CHF/kWh,
 *     16 h/jour) : 1000 * 10 * 0.6 = 6000 CHF ; eco annuelle 6307 / 12 = 525.6 CHF/mois ;
 *     payback = 11.4 mois (affiche 11).
 *   Les reglages fog_power / fog_price (prix du Black Series 600W) n'entraient dans aucun
 *   calcul : retires le 14/10/2026 (constat D5 de la relecture).
 * Le coefficient 0.6 est ajustable via le setting Shopify "Coefficient payback".
 *
 * Fourchette (28/10/2026, demande de Fabrizio : « un retour sur investissement de 12 a
 * 18 mois ») : la carte affiche « 12 a 18 mois » avec les valeurs par defaut, et la
 * fourchette suit la saisie. Coefficients 0.63 et 0.95 CHF/W (au lieu de 0.6) :
 * 10000 W x 0.63 / 525.6 = 12.0 mois ; 10000 W x 0.95 / 525.6 = 18.1 mois (affiche 18).
 */

(function () {
  'use strict';

  /* ---- Saisie décimale ---- */

  /* Champ texte et non number (voir roi-calculator.liquid) : on accepte « 0,35 » comme
     « 0.35 ». Toute autre forme (lettres, deux séparateurs comme « 1.234,5 ») donne NaN,
     donc « -- » à l'affichage, jamais un nombre faux. */
  function parseDecimal(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!/^(\d+([.,]\d*)?|[.,]\d+)$/.test(s)) return NaN;
    return parseFloat(s.replace(',', '.'));
  }

  /* ---- Bootstrap ---- */

  function init() {
    var section = document.querySelector('[data-roi-calculator]');
    if (!section) return;

    /* Réglage texte du marchand : « 0,5 » doit valoir 0.5, pas 0 (repli 0.6 silencieux). */
    var paybackCoef = parseDecimal(section.dataset.paybackCoef);
    if (isNaN(paybackCoef) || paybackCoef <= 0) paybackCoef = 0.63;
    var paybackCoefMax = parseDecimal(section.dataset.paybackCoefMax);
    if (isNaN(paybackCoefMax) || paybackCoefMax < paybackCoef) paybackCoefMax = Math.max(0.95, paybackCoef);
    /* Gabarit traduit, ex. « __MIN__ à __MAX__ » (cle pages.roi.payback_range). */
    var rangeTemplate = section.dataset.paybackRange || '__MIN__ - __MAX__';

    var inputPower  = document.getElementById('roi-input-power');
    var inputQty    = document.getElementById('roi-input-qty');
    var inputType   = document.getElementById('roi-input-type');
    var inputKwh    = document.getElementById('roi-input-kwh');
    var inputHours  = document.getElementById('roi-input-hours');

    if (!inputPower || !inputQty || !inputType || !inputKwh || !inputHours) return;

    var outputs = {
      case1:  document.getElementById('roi-out-case1'),
      case2:  document.getElementById('roi-out-case2'),
      case4:  document.getElementById('roi-out-case4'),
      case5:  document.getElementById('roi-out-case5'),
      case6:  document.getElementById('roi-out-case6'),
      case7:  document.getElementById('roi-out-case7'),
      case9:  document.getElementById('roi-out-case9'),
      case11: document.getElementById('roi-out-case11'),
      case12: document.getElementById('roi-out-case12'),
      case13: document.getElementById('roi-out-case13'),
      case14: document.getElementById('roi-out-case14')
    };

    /* ---- Calcul ---- */

    function calculate(values) {
      var power = values.power;
      var qty   = values.qty;
      var kwh   = values.kwh;
      var hours = values.hours;

      /* Consommation annuelle en kWh : (kW × heures/jour) × 365 */
      var dailyConsumption = ((power * qty) / 1000) * hours;
      var case5  = dailyConsumption * 365;        // Conso actuelle 1 an (kWh)
      var case6  = case5 * 0.6;                   // Conso FOG 1 an (kWh) — 60% de l'actuelle
      var case7  = case5 - case6;                 // Économie 1 an (kWh)
      var case13 = case7 * kwh;                   // Économie / Perte annuelle (CHF)
      var case9  = case13 / 12;                   // Économie / Perte mensuelle (CHF)
      var case14 = case13 * 5;                    // Économie / Perte 5 ans (CHF)
      var case1  = case13;                        // Économie 1 an (CHF) = annuelle
      var case2  = case14;                        // Économie 5 ans (CHF)
      var case11 = case13;                        // Gain annuel (CHF)
      var case12 = case14;                        // Gain 5 ans (CHF)
      /* Payback (mois) : (puissance remplacee * coef CHF/W) / economie mensuelle.
         Independant de la puissance unitaire si le ratio puissance/conso reste constant.
         Coef ajustable via setting Shopify "Coefficient payback" (defaut 0.6). */
      var case4  = case9 > 0 ? (power * qty * paybackCoef) / case9 : 0;
      var case4Max = case9 > 0 ? (power * qty * paybackCoefMax) / case9 : 0;

      return {
        case1:  case1,
        case2:  case2,
        case4:  case4,
        case4Max: case4Max,
        case5:  case5,
        case6:  case6,
        case7:  case7,
        case9:  case9,
        case11: case11,
        case12: case12,
        case13: case13,
        case14: case14
      };
    }

    function readInputs() {
      return {
        power: parseFloat(inputPower.value),
        qty:   parseFloat(inputQty.value),
        type:  inputType.value,
        kwh:   parseDecimal(inputKwh.value),
        hours: parseFloat(inputHours.value)
      };
    }

    function run() {
      var v = readInputs();

      /* Hors bornes (plus de 24 h par jour, nombre de lampes non entier) : « -- »
         plutôt qu'un résultat calculé sur une saisie impossible ou tronquée. */
      if (isNaN(v.power) || v.power <= 0 ||
          isNaN(v.qty)   || v.qty   <= 0 || v.qty % 1 !== 0 ||
          isNaN(v.kwh)   || v.kwh   <= 0 ||
          isNaN(v.hours) || v.hours <= 0 || v.hours > 24) {
        clearResults();
        return;
      }

      setResults(calculate(v));
    }

    /* ---- Affichage ---- */

    function setResults(r) {
      updateOutput(outputs.case1,  r.case1,  0);
      updateOutput(outputs.case2,  r.case2,  0);
      updateRange(outputs.case4, r.case4, r.case4Max);
      updateOutput(outputs.case5,  r.case5,  0);
      updateOutput(outputs.case6,  r.case6,  0);
      updateOutput(outputs.case7,  r.case7,  0);
      updateOutput(outputs.case9,  r.case9,  0);
      updateOutput(outputs.case11, r.case11, 0);
      updateOutput(outputs.case12, r.case12, 0);
      updateOutput(outputs.case13, r.case13, 0);
      updateOutput(outputs.case14, r.case14, 0);
    }

    function clearResults() {
      Object.keys(outputs).forEach(function (key) {
        var el = outputs[key];
        if (el) el.textContent = '--';
      });
    }

    function updateOutput(el, value, decimals) {
      if (!el) return;
      if (value === null || value === undefined || isNaN(value)) {
        el.textContent = '--';
        return;
      }
      if (value === 0) {
        el.textContent = '0';
        return;
      }
      el.textContent = formatNumber(value, decimals);
    }

    /* Fourchette du retour sur investissement : « 12 à 18 », ou un seul nombre si
       les deux bornes arrondies se confondent. */
    function updateRange(el, min, max) {
      if (!el) return;
      if (isNaN(min) || isNaN(max)) { el.textContent = '--'; return; }
      var a = formatNumber(min, 0);
      var b = formatNumber(max, 0);
      el.textContent = a === b ? a : rangeTemplate.replace('__MIN__', a).replace('__MAX__', b);
    }

    /* ---- Formatage ---- */

    function formatNumber(n, decimals) {
      var rounded = Math.round(n * Math.pow(10, decimals)) / Math.pow(10, decimals);
      try {
        /* Separateur de milliers suisse « 6'307 » dans toutes les langues.
           en-US donne la virgule a remplacer et le point decimal suisse ;
           it-CH ne grouperait pas les nombres a 4 chiffres. */
        return rounded.toLocaleString('en-US', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }).replace(/,/g, "'");
      } catch (e) {
        return rounded.toFixed(decimals);
      }
    }

    /* ---- Evenements ---- */

    inputPower.addEventListener('input', run);
    inputQty.addEventListener('input', run);
    inputType.addEventListener('change', run);
    inputKwh.addEventListener('input', run);
    inputHours.addEventListener('input', run);

    /* Calcul initial */
    run();
  }

  /* ---- Point d'entree ---- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
